import { useCallback, useEffect, useRef, useState } from 'react'

const useElementDimensions = <T extends HTMLDivElement>() => {
  const dimensionsRef = useRef<T>(null)
  const [dimensions, setDimensions] = useState<DOMRect | null>(null)

  const refresh = useCallback(() => {
    const domRect = dimensionsRef.current?.getBoundingClientRect()
    if (domRect) setDimensions(domRect)
  }, [])

  useEffect(() => {
    const el = dimensionsRef.current
    if (!el) return

    const observer = new ResizeObserver(refresh)
    observer.observe(el)
    refresh() // capture initial size

    return () => observer.disconnect()
  }, [refresh])

  return { dimensions, dimensionsRef, refresh }
}

export default useElementDimensions